import { createContext } from "react";
const ServerAvailabilityContext = createContext(void 0);
export default ServerAvailabilityContext;
